import { RegisterButton } from "./RegisterButton";
import { LoginForm } from "./Forms/LoginForm";
import { useContext, useRef } from "react";
import { AppContext } from "../../contexts/AppContext";
import { IntranetButton } from "./Shared/IntranetButton";

export const RightHandNavLoggedOut = () => {
    const app = useContext(AppContext);
    const closeCanvasButtonRef = useRef(null);

    const extraButtonAction = () => {
        closeCanvasButtonRef?.current.click();
    }

    return (<>
        {!app.userLoggedIn &&
            <div className="offcanvas-lg offcanvas-end flex-grow-1 header-buttons" tabIndex={-1} id="rhmNavbar" aria-labelledby="rhmNavbarOffcanvasLabel" data-bs-scroll="true">
                {/* Mobile view RHM */}
                <div className="offcanvas-header bg-primary">
                    <button type="button" ref={closeCanvasButtonRef} className="btn btn-nav-close" id="close-righthand-menu" data-bs-dismiss="offcanvas" aria-label="Close" data-bs-target="#rhmNavbar"><i className="fa-solid fa-x"></i></button>
                </div>
                <div className="offcanvas-body">
                    <div className="navbar-nav flex-row flex-wrap ms-md-auto">
                        <div className="d-flex justify-content-end list-group flex-column flex-lg-row w-100 gap-2">
                            <div className="w-100 mob-only">
                                {/* Mobile view */}
                                <LoginForm onCompleteCallback={() => { } } redirectToParams={""} showHeaderTitle={true}/>
                                <IntranetButton onClick={extraButtonAction} extraClasses="w-100 mt-4" />
                            </div>
                            <>
                                <div className="widescreen-only">
                                    <IntranetButton onClick={extraButtonAction} />
                                </div>
                                <RegisterButton />
                                <div className="dropdown widescreen-only">
                                    <button type="button" className="btn btn-contrast dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                        Login
                                    </button>
                                    <form className="dropdown-menu p-4 dropdown-menu-end w-400">
                                        <LoginForm onCompleteCallback={() => { } } redirectToParams={""} showHeaderTitle={true}/>
                                    </form>
                                </div>
                            </>
                        </div>
                    </div>

                </div>
            </div>}
    </>);
}